export default __webpack_public_path__ + "locales/lo-LA/EmbeddingPanel.json?hash=656506addc631af14e3483c6a341d31b";